// extracted by mini-css-extract-plugin
export default {"GiftwrapContent":"Giftwrap_GiftwrapContent__fJfBO","GiftwrapImg":"Giftwrap_GiftwrapImg__fYmdN"};